import styled from 'styled-components';

interface BgColorProp {
  background: string;
}

export const Wrapper = styled.section<BgColorProp>`
  background-image: url(${(props) => props.background});
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background-fit: contain;
`;

export const InnerWrapper = styled.div`
  max-width: 1384px;
  padding: 0 16px;
  box-sizing: border-box;
  margin: auto;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;

  @media (max-width: 874px) {
    flex-direction: column;
  }
`;

export const Column = styled.div`
  max-width: 653px;
  margin: 0 8px;
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: 874px) {
    margin: 0 auto 79px;
  }
`;

export const Header = styled.h2`
  margin: 31% 0 6%;
  width: 100%;
  min-height: 96px;
  font-family: MuseoSansRoundedBold;
  font-size: 45px;
  font-weight: 900;
  line-height: 0.92;
  color: #1b62ad;
  height: 135px;

  @media (max-width: 875px) {
    height: auto;
  }

  @media(max-width: 405px) {
    font-size: 34px;
  }
`;

export const Text = styled.p`
  font-family: Causten;
  font-size: 22px;
  line-height: 1.59;
  color: #5e5e5e;
  background-color: #fff;
  box-shadow: 1px 1px 15px #fff;
  width: 100%;
`;
